export default __webpack_public_path__ + "static/media/ftmgdelispiritlp.58a86378.png";